import React from 'react';
import withReduxContainer, { ContainerProps } from './Zone.container';
import {
  withSectionContext,
  WithSectionContextProps,
} from '../../Sections/SectionContext';

import Zone, { Props } from './Zone';
export type Props = Props;
export { default as ZoneGroup } from './ZoneGroup';
export default withSectionContext(
  withReduxContainer(Zone)
) as React.ComponentClass<
  Without<ContainerProps, keyof WithSectionContextProps>
>;
